<template>
  <b-row>
    <b-col md="4" sm="12">
      <label class="form-control-label">{{ $t('global.messageType') }}:</label>
      <b-form-group>
        <b-form-radio-group
          v-model="filters.messageType"
          :options="radioOptions"
          buttons
          button-variant="outline-primary"
          name="radios-btn-default"
        ></b-form-radio-group>
      </b-form-group>
    </b-col>
    <b-col md="4" sm="12">
      <b-form-group>
        <label>{{$t('views.excmmessages.list.createdAt') + ' '
        + $t('global.smFrom')}}:</label>
        <VueCtkDateTimePicker no-header
                              :label="$t('views.excmmessages.list.createdAt') + ' '
                                  + $t('global.smFrom')"
                              v-model.lazy="filters['createdAt[after]']"
                              v-debounce="delay"
                              format="YYYY-MM-DD"
                              :onlyDate="true"
                              :right="true"
                              formatted="ll"
        >
        </VueCtkDateTimePicker>
      </b-form-group>
    </b-col>
    <b-col md="4" sm="12">
      <b-form-group>
        <label>{{$t('views.excmmessages.list.createdAt')  + ' '
        + $t('global.smTo')}}:</label>
        <VueCtkDateTimePicker no-header
                              :label="$t('views.excmmessages.list.createdAt')  + ' '
                                  + $t('global.smTo')"
                              v-model.lazy="filters['createdAt[before]']"
                              v-debounce="delay"
                              format="YYYY-MM-DD"
                              :onlyDate="true"
                              :right="true"
                              formatted="ll"
        >
        </VueCtkDateTimePicker>
      </b-form-group>
    </b-col>
    <b-col md="4" sm="12">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.excmmessages.list.recipientPhoneEmail') }}:</label>
        <input v-model.lazy="filters.messageRecipientFilter" v-debounce="delay" class="form-control" type="text" :placeholder="$t('views.excmmessages.list.recipientPhoneEmail')">
      </div>
    </b-col>
    <b-col md="4" sm="12">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.excmmessages.list.recipient') }}:</label><br>
        <base-select-input
          v-model="filters.messageRecipientUserDataFilter"
          :search-callback="userDataSearchCallback"
          :display-values="['fullName', 'firmname1']"
          :query-param="'userdata'"
          :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
        ></base-select-input>
      </div>
    </b-col>
    <b-col md="4" sm="12" v-if="!messageRecipientUserDataContractorFilter">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.firm.form.headquartersAndItsEmployees') }}:</label><br>
        <base-select-input
          v-model="filters.messageRecipientUserDataContractorFilter"
          :search-callback="userDataSearchCallback"
          :display-values="['fullName', 'firmname1']"
          :query-param="'userdata'"
          :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
        ></base-select-input>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import addParamsToQuery from '@/utils/addParamsToQuery'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import debounce from 'v-debounce'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput.vue'
import ApiService from '@/utils/ApiService'

export default {
  name: 'EXCMMessageFiltering',
  components: {
    BaseSelectInput,
    VueCtkDateTimePicker
  },
  props: {
    messageRecipientUserDataContractorFilter: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      delay: 500,
      radioOptions: [
        {
          value: '',
          text: this.$t('global.all')
        },
        {
          value: 1,
          text: this.$t('views.exsbmessagesperiodic.form.messageTypes.mail')
        },
        {
          value: 2,
          text: this.$t('views.exsbmessagesperiodic.form.messageTypes.sms')
        }
      ],
      filters: {
        messageType: '',
        'createdAt[after]': '',
        'createdAt[before]': '',
        messageRecipientFilter: '',
        messageRecipientUserDataFilter: '',
        messageRecipientUserDataContractorFilter: this.messageRecipientUserDataContractorFilter
      }
    }
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        let url = 'e_x_c_m_messages'
        this.getPage(addParamsToQuery(url, JSON.parse(JSON.stringify(this.filters))))
      }
    }
  },
  methods: {
    getPage (url) {
      this.$emit('getPage', url)
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    }
  },
  directives: {
    debounce
  }
}
</script>

<style scoped>

</style>
